/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agent_Policy_Destructive_Awaiting_DescriptionInputs */



/**
* | output |
* | --- |
* | "They run unattended at their confirmation level, but every action oneAI recognises as irreversible pauses for an approver until this setting is on and the ag..." |
*
* @param {Agent_Policy_Destructive_Awaiting_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const agent_policy_destructive_awaiting_description = /** @type {((inputs?: Agent_Policy_Destructive_Awaiting_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agent_Policy_Destructive_Awaiting_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie laufen auf ihrer Bestätigungsstufe unbeaufsichtigt, doch jede Aktion, die oneAI als unumkehrbar erkennt, wartet auf eine Freigabe, bis diese Einstellung aktiviert und beim Agenten selbst „Darf unumkehrbare Aktionen ohne Rückfrage ausführen“ angehakt ist; ein Aufruf, der zusätzlich gewöhnliche externe Schreibvorgänge enthält, braucht zusätzlich die Einstellung darüber. Nichts davon wird automatisch eingeschaltet.")
	return /** @type {LocalizedString} */ ("They run unattended at their confirmation level, but every action oneAI recognises as irreversible pauses for an approver until this setting is on and the agent's own “May take irreversible actions without asking” is ticked; a call that also contains ordinary external writes also needs the setting above. Nothing is switched on automatically.")
});